export default __webpack_public_path__ + "static/treatmentareas_legsafter-efc98445ce1797ad5a72fac4d2d19efc.webp";